import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconArchiveGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M14.3359 1.6665H1.66927C1.31565 1.6665 0.97651 1.80698 0.726462 2.05703C0.476413 2.30708 0.335938 2.64622 0.335938 2.99984V4.99984C0.335938 5.17665 0.406175 5.34622 0.5312 5.47124C0.656224 5.59627 0.825793 5.6665 1.0026 5.6665H15.0026C15.1794 5.6665 15.349 5.59627 15.474 5.47124C15.599 5.34622 15.6693 5.17665 15.6693 4.99984V2.99984C15.6693 2.64622 15.5288 2.30708 15.2787 2.05703C15.0287 1.80698 14.6896 1.6665 14.3359 1.6665Z"
        fill={fillColor}
      />
      <path
        d="M14.3333 6.6665H1.66667C1.48986 6.6665 1.32029 6.73674 1.19526 6.86177C1.07024 6.98679 1 7.15636 1 7.33317V12.9998C1 13.3535 1.14048 13.6926 1.39052 13.9426C1.64057 14.1927 1.97971 14.3332 2.33333 14.3332H13.6667C14.0203 14.3332 14.3594 14.1927 14.6095 13.9426C14.8595 13.6926 15 13.3535 15 12.9998V7.33317C15 7.15636 14.9298 6.98679 14.8047 6.86177C14.6797 6.73674 14.5101 6.6665 14.3333 6.6665ZM10.1667 8.99984C10.1667 9.22085 10.0789 9.43281 9.92259 9.58909C9.76631 9.74537 9.55435 9.83317 9.33333 9.83317H6.66667C6.44565 9.83317 6.23369 9.74537 6.07741 9.58909C5.92113 9.43281 5.83333 9.22085 5.83333 8.99984C5.83333 8.77882 5.92113 8.56686 6.07741 8.41058C6.23369 8.2543 6.44565 8.1665 6.66667 8.1665H9.33333C9.55435 8.1665 9.76631 8.2543 9.92259 8.41058C10.0789 8.56686 10.1667 8.77882 10.1667 8.99984Z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconArchiveSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconArchiveGroup {...props} />
    </svg>
  );
};
